/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-globals */
import React, { useEffect, useRef, useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardHeader, Collapse, Table,
  Button, InputGroup, Nav, NavItem, NavLink, TabContent, TabPane,
} from 'reactstrap';
// import moment from 'moment';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import classnames from 'classnames';
import moment from 'moment';
import BaseGrid from '../../components/Common/BaseGrid';
import TVForm from '../../components/TVs/TVForm';

import { get, post, del } from '../../helpers/api_helper';
import Inspector from '../../components/Item/inspector';
// import { Can } from '../../utilities/Can';

function TVTeardown(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t } = props;

  document.title = t('TV Teardown');

  const sjnRef = useRef(null);

  const [sjn, setSjn] = useState(null);
  const [signal, setSignal] = useState(0);
  const [activeTab, setActiveTab] = useState('1');
  const [tv, setTV] = useState(null);
  const [editTv, setEditTv] = useState(false);
  const [part, setPart] = useState(null);
  const [kit, setKit] = useState([]);

  useEffect(() => {
    sjnRef.current.focus();
  }, []);

  useEffect(() => {
    const fetchTVBySJN = async () => {
      try {
        const data = await get(`/api/tvs/${sjn}`);

        setTV(data);
      } catch (error) {
        toastr.error(error.message, 'Error');
        setSjn(null);
        setTimeout(() => {
          sjnRef.current.focus();
        }, 200);
      }
    };

    const fetchTVByID = async () => {
      try {
        const data = await get(`/api/tvs/id/${sjn}`);

        setTV(data);
      } catch (error) {
        toastr.error(error.message, 'Error');
        setSjn(null);
        setTimeout(() => {
          sjnRef.current.focus();
        }, 200);
      }
    };

    if (sjn !== null) {
      if (sjn.match(/^[A-Z0-9]{4}$/)) {
        fetchTVBySJN();
      } else if (sjn.match(/^[0-9]{6}$/)) {
        fetchTVByID();
      }
    } else {
      setTV(null);
    }
  }, [sjn]);

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const addToKit = (item) => {
    const newKit = [...kit];
    newKit.push(item);

    setKit(newKit);
  };

  const processKit = async (k) => {
    try {
      const ids = k.items.map((x) => (x.id));

      let remoteKit = null;
      if (k !== null) {
        remoteKit = await get(`/api/burnsville/kit?sku=${encodeURIComponent(k.sku)}&items=${ids.join(',')}`);
      } else {
        remoteKit = await get(`/api/burnsville/kit?items=${ids.join(',')}`);
      }

      // print label
      await post(`/api/burnsville/printDZLabel/${remoteKit.stock_id}`, {
        lot: tv.order.lot,
        part_number: remoteKit.sku || `KIT-${remoteKit.stock_id}`,
        serial: `${remoteKit.stock_id}${Math.random().toString(36).substring(2, 8).toUpperCase()}`,
      });

      // log part as printed
      // refresh history
      ids.forEach(async (id) => {
        await post('/api/tvs/parts', {
          tv_id: tv.id,
          item_id: id,
        });
      });

      toastr.success('Label printed', 'Success');

      setSignal(signal + 1);
      setKit([]);
      setPart(null);
      setActiveTab('1');
      setEditTv(false);
      setSjn(null);
      setTV(null);
    } catch (error) {
      toastr.error(error.message, 'Error');
    }
  };

  const processItem = async (item) => {
    try {
      const remoteItem = await get(`/api/burnsville/inventoryByItemId/${item.id}`);

      // print label
      await post(`/api/burnsville/printDZLabel/${remoteItem.stock_id}`, {
        lot: tv.order.lot,
        part_number: item.part_number,
      });

      // log part as printed
      // refresh history
      await post('/api/tvs/parts', {
        tv_id: tv.id,
        item_id: item.id,
      });

      toastr.success('Label printed', 'Success');

      setSignal(signal + 1);
      setKit([]);
      setPart(null);
      setActiveTab('1');
      setEditTv(false);
      setSjn(null);
      setTV(null);
    } catch (error) {
      toastr.error(error.message, 'Error');
    }
  };

  const deleteLog = async (log) => {
    try {
      await del(`/api/tvs/parts/${log.id}`);

      toastr.success('Log deleted', 'Success');
      setSignal(signal + 1);
    } catch (error) {
      toastr.error(error.message, 'Error');
    }
  };

  const printTVLabel = async () => {
    try {
      await get(`/api/tvs/print/${tv.id}`);
      toastr.success('Label printed', 'Success');
    } catch (error) {
      toastr.error(error.message, 'Error');
    }
  };

  const strippedTags = ['TV Parts', 'Internal Parts', 'Offer'];

  return (
    <div className="page-content">
      <div className="container-fluid">
        {sjn === null && (
          <Row className="mt-4">
            <Col sm="4" />
            <Col sm="4">
              <Card>
                <CardBody className="p-4">
                  <Row>
                    <Col sm="2" />
                    <Col sm="8">
                      <InputGroup>
                        <input
                          ref={sjnRef}
                          type="text"
                          placeholder={t('Scan or type SJN')}
                          className="form-control input-lg bg-secondary bg-soft"
                          style={{ textTransform: 'uppercase' }}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              setSjn(sjnRef.current.value.replace(/^X/, '').toUpperCase());
                            }
                          }}
                        />
                        <Button color="primary" size="lg" className="ml-2" onClick={() => { setSjn(sjnRef.current.value.toUpperCase()); }}>{t('Search')}</Button>
                      </InputGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}

        {sjn !== null && (
          <Row>
            <Col xl="4">
              <Card>
                <CardHeader className="border-bottom bg-transparent">
                  {t('TV Details')}
                </CardHeader>
                <CardBody>
                  <>
                    <div>
                      {tv && (
                        <>
                          <Table size="sm" className="mt-3" striped bordered>
                            <tbody>
                              <tr>
                                <td>{props.t('Brand/Model Ver.')}</td>
                                <td>{`${tv.brand} ${tv.model} ${tv.version ? tv.version : ''}`}</td>
                              </tr>
                              <tr>
                                <td>{props.t('Inducted By')}</td>
                                <td>{`${tv.user && tv.user.display_name} @ ${moment(tv.created_at).format('YYYY-MM-DD HH:mm:ss')}`}</td>
                              </tr>
                              {tv.device && tv.device.marketing_title && (
                              <tr>
                                <td>{props.t('Title')}</td>
                                <td>{tv.device.marketing_title}</td>
                              </tr>
                              )}
                              <tr>
                                <td>{props.t('Classification')}</td>
                                <td><strong>{tv.classification}</strong></td>
                              </tr>
                              <tr>
                                <td>{props.t('Lot')}</td>
                                <td><strong>{tv.order && tv.order.lot}</strong></td>
                              </tr>
                            </tbody>
                          </Table>

                          <Button size="sm" color="light" className="me-2" onClick={() => { setSjn(null); setPart(null); }}>
                            <span className="mdi mdi-arrow-left" />
                            {' '}
                            {t('Back')}
                          </Button>

                          <Button size="sm" color="light" className="me-2" onClick={() => { printTVLabel(); }}>
                            <span className="mdi mdi-printer" />
                            {' '}
                            {t('Print TV Label')}
                          </Button>

                          {editTv === false && (
                          <Button size="sm" color="warning" className="btn-soft-warning text-dark" onClick={() => { setEditTv(!editTv); }}>
                            <span className="mdi mdi-pencil" />
                            {' '}
                            {t('Edit')}
                          </Button>
                          )}
                        </>
                      )}
                    </div>
                    <Collapse isOpen={editTv} className="accordion-collapse mt-3">
                      <TVForm
                        sjn={sjn}
                        onCancel={() => { setEditTv(false); }}
                        onSuccess={() => { setSignal(signal + 1); setEditTv(false); }}
                      />
                    </Collapse>
                  </>
                </CardBody>
              </Card>

              <Collapse isOpen={kit.length > 0} className="accordion-collapse mt-3">
                <Card>
                  <CardHeader className="border-bottom bg-transparent">
                    {t('Kit Builder')}
                  </CardHeader>
                  <CardBody>
                    <Table size="sm" className="table table-sm table-bordered table-hover">
                      <thead>
                        <tr>
                          <th>{t('Thumb')}</th>
                          <th>{t('ID')}</th>
                          <th>{t('Part Number')}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {kit.map((item) => (
                          <tr key={item.id}>
                            <td className="align-middle">
                              <img src={`/api/items/thumbnail/${item.id}`} alt={item.part_number} className="rounded" style={{ maxHeight: '3rem', maxWidth: '3rem' }} />
                            </td>
                            <td className="align-middle">
                              <Button color="link" onClick={() => { setPart(item); }}>
                                {item.id}
                              </Button>
                            </td>
                            <td className="align-middle">
                              <Button color="link" onClick={() => { setPart(item); }}>
                                {item.part_number}
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <Button size="sm" color="warning" className="ms-2 btn-soft-warning text-dark" onClick={() => { setKit([]); }}>{t('Clear Kit')}</Button>
                  </CardBody>
                </Card>
              </Collapse>

              <Collapse isOpen={part !== null} className="accordion-collapse">
                <Card>
                  <CardHeader className="border-bottom bg-transparent">
                    {t('Part Inspection')}
                  </CardHeader>
                  <CardBody>
                    {part !== null && (
                      <Inspector item={part} device={tv.device} />
                    )}

                    <Button size="sm" color="light" onClick={() => { setPart(null); }}>{t('Close')}</Button>
                  </CardBody>
                </Card>
              </Collapse>
            </Col>

            <Col xl="8">
              <Nav tabs style={{ borderBottom: 'none' }}>
                <NavItem style={{ borderBottom: 'none' }}>
                  <NavLink
                    style={{ cursor: 'pointer' }}
                    className={classnames({
                      active: activeTab === '1',
                      'bg-warning': activeTab === '1',
                      'text-muted': activeTab !== '1',
                      'text-dark': activeTab === '1',
                    })}
                    onClick={() => {
                      toggle('1');
                    }}
                  >
                    {t('Associated Parts')}
                  </NavLink>
                </NavItem>
                <NavItem style={{ borderBottom: 'none' }}>
                  <NavLink
                    style={{ cursor: 'pointer' }}
                    className={classnames({
                      active: activeTab === '3',
                      'bg-warning': activeTab === '3',
                      'text-muted': activeTab !== '3',
                      'text-dark': activeTab === '3',
                    })}
                    onClick={() => {
                      toggle('3');
                    }}
                  >
                    {t('Kit Helper')}
                  </NavLink>
                </NavItem>
                <NavItem style={{ borderBottom: 'none' }}>
                  <NavLink
                    style={{ cursor: 'pointer' }}
                    className={classnames({
                      active: activeTab === '4',
                      'bg-warning': activeTab === '4',
                      'text-muted': activeTab !== '4',
                      'text-dark': activeTab === '4',
                    })}
                    onClick={() => {
                      toggle('4');
                    }}
                  >
                    {t('History')}
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent activeTab={activeTab} className="p-3 text-muted bg-light">
                <TabPane tabId="1">
                  {tv !== null && (
                    <BaseGrid
                      url={`/api/tvs/parts/associated/${tv.id}`}
                      className="table table-sm fs-6 table-nowrap table-hover table-bordered"
                      hasSearch
                      shouldUpdate={signal}
                      config={
                      {
                        rowClass: (ent) => {
                          if (part !== null && part.id === ent.id) {
                            return 'table-info';
                          }

                          return '';
                        },
                        columns: {
                          thumb: {
                            label: '',
                            image: {
                              src: (item) => (`/api/items/thumbnail/${item.id}`),
                              class: 'rounded',
                              style: { maxHeight: '3rem', maxWidth: '3rem' },
                            },
                            translate: false,
                          },
                          id: {
                            label: props.t('ID'),
                            sort: true,
                            link: {
                              click: (item) => { setPart(item); },
                            },
                          },
                          part_number: {
                            label: props.t('Part Number'),
                            sort: true,
                            link: {
                              click: (item) => { setPart(item); },
                            },
                          },
                          boardNumbers: {
                            label: props.t('Board Numbers'),
                            html: true,
                            format: (f) => {
                              const bns = f.map((b) => (b.label === 'Visible Number' ? b.value : '')).filter((x) => x !== '').join('<br />');

                              return bns;
                            },
                          },
                          qty: {
                            label: props.t('Qty / Scrap'),
                            sort: true,
                            format: (f, x) => {
                              let qty = f;
                              if (x.scrap !== null && x.scrap > -1) {
                                qty = `${f ? f.toString() : ''} / ${x.scrap ? x.scrap.toString() : ''}`;
                              }

                              return qty;
                            },
                          },
                          mnfctrpn: {
                            label: props.t('Mfr. Prt No'),
                            html: true,
                            format: (f, x) => {
                              const bns = x.boardNumbers.map((b) => (b.label === 'Manufacturer Part Number' ? b.value : ''))
                                .map((c) => c.replace(x.manufacturer, '').trim())
                                .filter((y) => y !== '' && y !== x.part_number)
                                .join('<br />');

                              return bns;
                            },
                          },
                          tags: {
                            label: 'Tags',
                            format: (x) => (x.map((r) => (!strippedTags.includes(r.label) ? r.label : '')).filter((y) => x !== '')),
                            sort: true,
                            badges: {
                              class: 'bg-info bg-soft text-dark p-1',
                            },
                          },
                          version: {
                            label: props.t('Ver?'),
                            sort: false,
                            html: true,
                            format: (x, row) => {
                              let html = '';
                              row.devices.forEach((device) => {
                                if (device.version === '' || (device.version && device.version.includes(tv.version))) {
                                  html = '<span class="badge bg-success bg-soft text-dark p-2"><span class="mdi mdi-check"></span></span>';
                                } else if (tv.version == null) {
                                  html = '<span class="badge bg-warning bg-soft text-dark p-2"><span class="mdi mdi-alert"></span></span>';
                                } else {
                                  html = '<span class="badge bg-danger bg-soft text-dark p-2"><span class="mdi mdi-close-thick"></span></span>';
                                }
                              });

                              return html;
                            },
                          },
                          actions: {
                            label: props.t('Actions'),
                            actions: [
                              {
                                key: 'print',
                                icon: 'mdi mdi-printer',
                                class: 'btn btn-sm btn-soft-dark',
                                alt: props.t('Print'),
                                click: processItem,
                              },
                              // {
                              //   key: 'select',
                              //   icon: 'mdi mdi-plus',
                              //   class: 'btn btn-sm btn-soft-success ms-3',
                              //   condition: (item) => (
                              //     kit.filter((x) => x.id === item.id).length === 0
                              //   ),
                              //   alt: props.t('Add to Kit'),
                              //   click: (item) => {
                              //     addToKit(item);
                              //   },
                              // },
                              // {
                              //   key: 'remove',
                              //   icon: 'mdi mdi-close-thick',
                              //   class: 'btn btn-sm btn-danger ms-3',
                              //   condition: (item) => (
                              //     kit.filter((x) => x.id === item.id).length > 0
                              //   ),
                              //   alt: props.t('Remove from Kit'),
                              //   click: (item) => {
                              //     const newKit = kit.filter((x) => x.id !== item.id);
                              //     setKit(newKit);
                              //   },
                              // },
                            ],
                          },
                        },
                        pagination: {
                          sort: 'tags',
                          direction: 'asc',
                          perPage: 30,
                        },
                      }
                      }
                    />
                  )}
                </TabPane>

                <TabPane tabId="3">
                  {tv !== null && activeTab === '3' && (
                    <BaseGrid
                      url={`/api/tvs/parts/kits/${tv.id}`}
                      className="table table-sm fs-6 table-nowrap table-hover table-bordered"
                      hasSearch
                      config={
                      {
                        columns: {
                          thumb: {
                            label: '',
                            image: {
                              src: (lst) => (`/api/listings/thumbnail/${lst.id}`),
                              class: 'rounded',
                              style: { maxHeight: '3rem', maxWidth: '3rem' },
                            },
                            translate: false,
                          },
                          id: {
                            label: props.t('ID'),
                            sort: true,
                          },
                          sku: {
                            label: props.t('SKU'),
                            sort: true,
                            link: {
                              click: (lst) => {
                                setKit([...lst.items]);
                              },
                            },
                          },
                          boardNumbers: {
                            label: props.t('Mnfr PN'),
                            html: true,
                            format: (f, x) => {
                              const bns = x.items.map((itm) => itm.boardNumbers).flat().filter((y) => ['Manufacturer Part Number'].includes(y.label.trim())).map((w) => w.value)
                                .join('<br />');

                              const atts = x.attributes.filter((y) => ['Manufacturer Part Number'].includes(y.label)).map((w) => w.code)
                                .join('<br />');

                              return `${bns}<br />${atts}`;
                            },
                          },
                          last_qty: {
                            label: props.t('Qty'),
                          },
                          items: {
                            label: props.t('Parts'),
                            translate: false,
                            format: (i) => i.map((x) => (
                              <div>
                                <Button
                                  className="p-0 m-0"
                                  style={{
                                    fontSize: '11px',
                                    color: x.devices.map((dev) => dev.id).includes(tv.device.id) ? '#0B0' : '#668',
                                  }}
                                  color="link"
                                  onClick={() => { setPart(x); }}
                                >
                                  {x.part_number}
                                </Button>
                              </div>
                            )), // XSS risk
                          },
                          actions: {
                            label: props.t('Actions'),
                            actions: [
                              {
                                key: 'print',
                                icon: 'bx bx-printer',
                                class: 'btn btn-sm btn-soft-dark',
                                alt: props.t('Process'),
                                click: processKit,
                              },
                            ],
                          },
                        },
                        pagination: {
                          sort: 'sku',
                          direction: 'asc',
                          perPage: 30,
                        },
                      }
                      }
                    />
                  )}
                </TabPane>

                <TabPane tabId="4">
                  <BaseGrid
                    url="/api/tvs/parts"
                    shouldUpdate={signal}
                    className="table table-sm fs-6 table-nowrap table-hover table-bordered"
                    hasSearch
                    config={
                    {
                      rowClass: (ent) => {
                        if (part !== null && part.id === ent.id) {
                          return 'table-info';
                        }
                        return '';
                      },
                      columns: {
                        thumb: {
                          label: '',
                          image: {
                            src: (log) => (`/api/items/thumbnail/${log.item.id}`),
                            class: 'rounded',
                            style: { maxHeight: '3rem', maxWidth: '3rem' },
                          },
                          translate: false,
                        },
                        user: {
                          label: props.t('User'),
                          sort: true,
                        },
                        created_at: {
                          label: props.t('Date'),
                          sort: true,
                          format: (f) => (moment(f).format('YYYY-MM-DD HH:mm:ss')),
                        },
                        tv: {
                          label: props.t('TV'),
                          sort: true,
                          format: (f) => (`${f.brand} ${f.model} ${f.version || ''} (${f.sjn})`),
                        },
                        manufacturer: {
                          label: props.t('Manufacturer'),
                          sort: true,
                          format: (f, x) => (x.item.manufacturer),
                        },
                        part_number: {
                          label: props.t('Part Number'),
                          sort: true,
                          format: (f, x) => (x.item.part_number),
                        },
                        condition: {
                          label: props.t('Condition'),
                          sort: true,
                          format: (f, x) => (x.item.condition.substring(0, 8)),
                        },
                        actions: {
                          label: props.t('Actions'),
                          actions: [
                            {
                              key: 'remove',
                              icon: 'mdi mdi-close-thick',
                              class: 'btn btn-sm btn-danger ms-3',
                              alt: props.t('Delete Log'),
                              click: deleteLog,
                            },
                          ],
                        },
                      },
                      pagination: {
                        sort: 'id',
                        direction: 'desc',
                        perPage: 30,
                      },
                    }
                    }
                  />
                </TabPane>
              </TabContent>
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
}

TVTeardown.defaultProps = {
  t: (x) => (x),
};

TVTeardown.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(TVTeardown));
